import axios from '@/libs/axios'
import modules from '@/apis/modules'

/**
 @typedef Module
 @property {Number|String} id
 @property {Array<Number|String>} farmer_ids
 @property {String} name
 @property {string} start
 @property {string} end
 @property {string} created_at
 @property {string} updated_at
 @property {string} deleted_at
 */

export default {
  namespaced: true,
  state: {
    /** @type {null|Array<Module>} modules */
    modules: null,
  },
  getters: {
    /**
     * @param state
     * @returns {boolean}
     */
    isFetch(state) {
      return state.modules !== null
    },
    /**
     * @param state
     * @returns {Array<string>}
     */
    getModules(state) {
      return state.modules
        .filter(module => module.enabled)
        .map(module => module.name)
    },
  },
  mutations: {
    /**
     * @param {Object} state
     */
    clear(state) {
      state.modules = null
    },
    /**
     * @param {Object} state
     * @param {Array<Module>} data
     * @returns {Promise<void>}
     */
    set(state, data) {
      state.modules = data
    },
  },
  actions: {
    /**
     * @param {Function} commit
     * @param {Object} rootGetters
     * @param {boolean} clearBefore
     * @returns {Promise<boolean>}
     */
    async fetch({
      commit,
      rootGetters,
    }, clearBefore = false) {
      /** @type {AxiosResponse<loginResponse>} response */
      const response = await (axios(modules.list(
        rootGetters['auth/getToken'],
      )))

      if (clearBefore) commit('clear')
      commit('set', (response.data?.data ?? [])
        .filter(module => module.enabled))
    },
    async has({ state }, name) {
      if (state.modules === null) return false
      return (state.modules ?? [])
        .filter(module => module.enabled)
        .some(module => module.name === name)
    },
  },
}
